//@ts-nocheck
import { useEffect } from "react";

import { ProductKeys } from "@atlassiansox/asc-stargate";

import { TemplateCategory } from "@/components/confluence/templates/template-categories-search";
import { CrossFlowTouchpointProvider } from "@/components/cross-flow/touchpoint";
import type {
    Template,
    TemplateCollection
} from "@/content/templates/template.types";
import { ConfluenceTemplateDetailsPageTemplate } from "@/templates/software/confluence/templates/confluence-templates-page/src";
import { experiments, useExperiment } from "@/utils/experiment";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

export type ConfluenceTemplateDetailsPageProps = {
    templates?: Template[];
    collections?: TemplateCollection[];
    categories?: TemplateCategory[];
};

export const ConfluenceTemplateDetailsPage = ({
    templates,
    collections,
    categories
}: ConfluenceTemplateDetailsPageProps) => {
    useEffect(() => {
        checkFeatureFlagGate(featureFlags.gwpRelayConfTemplateDetails);
    }, []);

    useEffect(() => {
        checkFeatureFlagGate(featureFlags.cpapiwdConfluenceTemplateDetails);
    }, []);

    return (
        <CrossFlowTouchpointProvider productKeys={[ProductKeys.CONFLUENCE]}>
            <ConfluenceTemplateDetailsPageTemplate
                templates={templates}
                collections={collections}
                categories={categories}
            />
        </CrossFlowTouchpointProvider>
    );
};
